export default __webpack_public_path__ + "static/media/advantage-1.7d878166.png";